var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-layout-sider",
    {
      class: [_vm.theme, "sider", _vm.isMobile ? null : "shadow"],
      attrs: { width: "256px", collapsible: _vm.collapsible, trigger: null },
      model: {
        value: _vm.collapsed,
        callback: function($$v) {
          _vm.collapsed = $$v
        },
        expression: "collapsed"
      }
    },
    [
      _c(
        "div",
        { class: ["logo", _vm.theme] },
        [
          _c("router-link", { attrs: { to: "/dashboard/workplace" } }, [
            _c("img", { attrs: { src: _vm.logSrc } }),
            _vm._v(" "),
            _c("h1", { staticStyle: { "letter-spacing": "3px" } }, [
              _vm._v(_vm._s(_vm.systemName))
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("i-menu", {
        attrs: {
          theme: _vm.theme,
          collapsed: _vm.collapsed,
          menuData: _vm.menuData
        },
        on: { select: _vm.onSelect, systemClick: _vm.systemClick }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35f1c38c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35f1c38c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/SiderMenu.vue
// module id = null
// module chunks = 